import EquipmentInventory from '../components/equipment/EquipmentInventory'

/**
 * VH-131: /equipment is now the "All equipment" view.
 *
 * It is no longer a top-level destination — equipment is reached through
 * Training Locations, because equipment is location-owned. The route survives
 * on purpose rather than redirecting: anyone with it bookmarked lands on the
 * cross-location list, which is the nearest true meaning of the old page, and
 * VH-130's reasoning still applies — there must always be a way to see every
 * machine at once, or a misplaced one can only be found by checking each place
 * in turn.
 */
export default function EquipmentManagement() {
  return <EquipmentInventory />
}
